import { create } from 'zustand';

export type ConfirmTone = 'primary' | 'danger';

interface ConfirmOptions {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: ConfirmTone;
  /** true 면 단일 확인 버튼만 표시 — alertModal() 헬퍼가 내부적으로 사용 */
  alertOnly?: boolean;
}

interface ConfirmState {
  open: boolean;
  options: ConfirmOptions | null;
  resolver: ((ok: boolean) => void) | null;
  show: (opts: ConfirmOptions) => Promise<boolean>;
  resolve: (ok: boolean) => void;
}

export const useConfirmStore = create<ConfirmState>((set, get) => ({
  open: false,
  options: null,
  resolver: null,
  show: (opts) =>
    new Promise<boolean>((resolve) => {
      /* 이전 대기 중이 있다면 취소(false) 로 종료 */
      const prev = get().resolver;
      if (prev) prev(false);
      set({ open: true, options: opts, resolver: resolve });
    }),
  resolve: (ok) => {
    const r = get().resolver;
    if (r) r(ok);
    set({ open: false, resolver: null });
  },
}));

/** 전역 confirm() 대체 함수. await 로 boolean 반환 */
export function confirmModal(opts: ConfirmOptions): Promise<boolean> {
  return useConfirmStore.getState().show(opts);
}

/**
 * 단일 버튼 alert. 사용자가 확인을 누를 때까지 await.
 * 브라우저 alert() 대체 — 시세공간 톤의 모달로 표시.
 */
export function alertModal(opts: {
  title?: string;
  message: string;
  confirmLabel?: string;
  tone?: ConfirmTone;
}): Promise<void> {
  return useConfirmStore.getState().show({ ...opts, alertOnly: true }).then(() => {});
}
